import { Box, HStack, Text } from 'native-base'
import React from 'react'
import { Trans } from 'react-i18next'

import HeaderLogo from '../HeaderLogo/HeaderLogo'
import { EmailSupportLink, WhatsappSupportLink } from '../Link/'

export const RegistrationOnboardingAlert = () => (
  <Box bg="primary.100" borderRadius="lg" px="4" py="3">
    <HStack justifyContent="space-between" alignItems="center" space={'md'}>
      <HeaderLogo logoSize="small" />
      <Box flex={1}>
        <Text>
          <Trans i18nKey="screens.welcome.registrationOrientation.intro">
            <WhatsappSupportLink />
            <EmailSupportLink />
          </Trans>
        </Text>
      </Box>
    </HStack>
  </Box>
)
